export enum EventType {
  BUSINESS_TRIP = 70,
  EVENT = 69,
}
